import { useEffect } from 'react';

// Desestímulo visual contra clique-direito / DevTools / view-source.
// IMPORTANTE: isso NÃO é segurança real, apenas dificulta o acesso casual.
// A proteção de verdade do sistema está no backend (auth, validação, RBAC).
const DisableInspect = () => {
  useEffect(() => {
    const blockContextMenu = (e) => e.preventDefault();

    const blockKeys = (e) => {
      const key = e.key;
      const ctrlOrCmd = e.ctrlKey || e.metaKey;

      if (
        key === 'F12' ||
        (ctrlOrCmd && e.shiftKey && ['I', 'i', 'J', 'j', 'C', 'c'].includes(key)) ||
        (ctrlOrCmd && ['U', 'u'].includes(key))
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener('contextmenu', blockContextMenu);
    document.addEventListener('keydown', blockKeys, true);

    return () => {
      document.removeEventListener('contextmenu', blockContextMenu);
      document.removeEventListener('keydown', blockKeys, true);
    };
  }, []);

  return null;
};

export default DisableInspect;
